import React from 'react';
import { Typography } from '@mui/material';
import { LabourItemDefinition } from '../../api/labourItemsApi';
import { LabourItemListItem } from '../molecules/LabourItemListItem';
import { ListViewShell } from '../../../../shared/components/ui/ListViewShell';

interface LabourItemsListViewProps {
  items: LabourItemDefinition[];
  loading: boolean;
  onMenuOpen: (event: React.MouseEvent<HTMLElement>, id: string) => void;
  disabled?: boolean;
}

export const LabourItemsListView: React.FC<LabourItemsListViewProps> = ({
  items,
  loading,
  onMenuOpen,
  disabled,
}) => {
  return (
    <ListViewShell
      itemCount={items.length}
      loading={loading}
      emptyMessage="No definitions found"
      columnHeaders={
        <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>
          Name
        </Typography>
      }
    >
      {items.map(item => (
        <LabourItemListItem
          key={item.id}
          item={item}
          onMenuOpen={onMenuOpen}
          disabled={disabled}
        />
      ))}
    </ListViewShell>
  );
};
